import Vue from 'vue';

// Vue Config
Vue.config.productionTip = false;
Vue.config.devtools = true;

// ----- Plugins -------
// Customs
import { KeySiteCore } from '../../mixins/KeySiteCore';
import UniqueIdPlugin from '../../plugins/UniqueIdPlugin.js';
import WindowWidthPlugin from '../../plugins/WindowWidthPlugin.js';
import VuePortal from '@linusborg/vue-simple-portal';

Vue.use(KeySiteCore);
Vue.use(UniqueIdPlugin);

Vue.use(VuePortal, {
	name: 'portal', // optional, use to rename component
});

// Vendors
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);
// ---------------------

// Components
import { DefaultTabs } from '@c/Tabs';
import AnimationKillswitch from '@c/AnimationKillswitch';
import ContentRevealUp from '@c/Animations/ContentRevealUp';
import DefaultButton from '@c/DefaultButton';
import DefaultCarousel from '@c/DefaultCarousel';
import DefaultContentBlock from '@c/DefaultContentBlock';
import DefaultModal from '@c/DefaultModal';
import DefaultPicture from '@c/DefaultPicture';
import DefaultSection from '@c/DefaultSection';
import DefaultHero from '@c/DefaultHero';
import DropdownNavigation from '@c/DropdownNavigation';
import HeroVideo from '@c/HeroVideo';
import ImageMosaic from '@c/ImageMosaic';
import ImageMosaicItem from '@c/ImageMosaicItem';
import ModalImageMosaic from '@c/ModalImageMosaic';
import ParallaxHorizontal from '@c/Animations/ParallaxHorizontal';
import ParallaxVertical from '@c/Animations/ParallaxVertical';
import ScrollRevealer from '@c/ScrollRevealer';
import ShowHero from '@c/ShowHero';
import SvgIcon from '@c/SvgIcon';
import VideoLoop from '@c/VideoLoop';
import VideoYoutubeIframe from '@c/VideoYoutubeIframe';
import VideoYoutubePlayer from '@c/VideoYoutubePlayer';
import Ornement from '@c/Ornement';

// Mixins
import ResponsiveBackgroundImageMixin from '../../mixins/ResponsiveBackgroundImageMixin.js';

// Utils
import store from '../../stores/storeVStar';

import './styles/main.scss';

new Vue({
	el: '#site',
	store,
	components: {
		AnimationKillswitch,
		ContentRevealUp,
		DefaultButton,
		DefaultCarousel,
		DefaultContentBlock,
		DefaultHero,
		DefaultModal,
		DefaultPicture,
		DefaultSection,
		DefaultTabs,
		DropdownNavigation,
		HeroVideo,
		ImageMosaic,
		ImageMosaicItem,
		ModalImageMosaic,
		Ornement,
		ParallaxHorizontal,
		ParallaxVertical,
		ScrollRevealer,
		ShowHero,
		SvgIcon,
		VideoLoop,
		VideoYoutubeIframe,
		VideoYoutubePlayer,
	},
	mixins: {
		ResponsiveBackgroundImageMixin,
	},
	created: function () {
		Vue.use(WindowWidthPlugin, this.$store);
	},
	mounted: function () {
		this.$el.style.opacity = 1;
	},
});
